import { checkTheme, config } from './config';

export const STYLE_KEY = 'claims-widget-style';

const scrollStyle = `
.axitech-widget-modal-open {
  position: fixed;
  overflow: hidden;
  width: 100%;
  left: 0;
  right: 0;
  min-height: 100vh;
  margin-left: calc(100vw - 100%) !important
}`;

function appendFontLink(url: string, id: string) {
  if (document.getElementById(id)) {
    return;
  }
  const link = document.createElement('link');
  link.id = id;
  link.href = url;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.crossOrigin = 'anonymous';
  document.head.append(link);
}

export async function loadFonts() {
  const theme = config.value.theme;
  if (typeof window === 'undefined' || !theme) return;
  const currentStyle = document.getElementById(`${STYLE_KEY}-font`);
  if (currentStyle) {
    currentStyle.remove();
  }
  const styleElem = document.createElement('style', {
    is: `${STYLE_KEY}-font`,
  });
  styleElem.id = `${STYLE_KEY}-font`;
  if (theme.primaryRegularUrl?.startsWith('https') && theme.secondaryRegularUrl?.startsWith('https')) {
    styleElem.innerHTML = `
      ${scrollStyle}
    `;
    document.head.append(styleElem);
    appendFontLink(theme.primaryRegularUrl, `${STYLE_KEY}-font-primary`);
    appendFontLink(theme.secondaryRegularUrl, `${STYLE_KEY}-font-secondary`);
    return;
  }
  if (checkTheme('crashdaddy', 'common')) {
    styleElem.innerHTML = `
      ${scrollStyle}
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/variable.ttf`)).default
        }') format('truetype-variations');
        font-weight: 400 700;
        font-stretch: 100% 130%;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/variable.ttf`)).default
        }') format('truetype-variations');
        font-weight: 400 700;
        font-stretch: 100% 130%;
        font-style: normal;
        font-display: swap;
      }
    `;
    document.head.append(styleElem);
    return;
  }
  if (checkTheme('audi')) {
    styleElem.innerHTML = `
      ${scrollStyle}
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/regular_primary.woff2`)).default
        }') format('woff2-variations');
        font-weight: 400 700;
        font-stretch: 100% 130%;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.secondaryRegularUrl || 'default'}/regular_secondary.woff2`)).default
        }') format('woff2-variations');
        font-weight: 400 700;
        font-stretch: 100% 130%;
        font-style: normal;
        font-display: swap;
      }
    `;
    document.head.append(styleElem);
    return;
  }
  if (checkTheme('mini', 'samsung', 'mopar', 'jeep', 'suzuki')) {
    styleElem.innerHTML = `
      ${scrollStyle}
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/regular_primary.woff`)).default
        }') format('woff');
        font-weight: 400;
        font-stretch: 100%;
        font-style: normal;
        font-display: swap;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
      }
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/bold_primary.woff`)).default
        }') format('woff');
        font-weight: bold;
        font-stretch: 100%;
        font-style: normal;
        font-display: swap;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.secondaryRegularUrl || 'default'}/regular_secondary.woff`)).default
        }') format('woff');
        font-weight: 400;
        font-stretch: 100%;
        font-style: normal;
        font-display: swap;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.secondaryRegularUrl || 'default'}/bold_secondary.woff`)).default
        }') format('woff');
        font-weight: bold;
        font-stretch: 100%;
        font-style: normal;
        font-display: swap;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
      }
    `;
    document.head.append(styleElem);
    return;
  }
  styleElem.innerHTML = `
      ${scrollStyle}
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryBoldUrl || 'default'}/regular_primary.woff2`)).default
        }') format('woff2');
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "WidgetPrimaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.primaryRegularUrl || 'default'}/bold_primary.woff2`)).default
        }') format("woff2");
        font-weight: bold;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.secondaryBoldUrl || 'default'}/regular_secondary.woff2`)).default
        }') format('woff2');
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "WidgetSecondaryFont";
        src: url('${
          (await import(`../assets/fonts/${theme.secondaryRegularUrl || 'default'}/bold_secondary.woff2`)).default
        }') format("woff2");
        font-weight: bold;
        font-style: normal;
        font-display: swap;
      }
    `;
  document.head.append(styleElem);
}
